import { render, staticRenderFns } from "./myProgramPackPage.vue?vue&type=template&id=56bd422a&scoped=true&"
import script from "./myProgramPackPage.vue?vue&type=script&lang=ts&"
export * from "./myProgramPackPage.vue?vue&type=script&lang=ts&"
import style0 from "./myProgramPackPage.vue?vue&type=style&index=0&id=56bd422a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bd422a",
  null
  
)

export default component.exports